import Video from './Video';

/**
 * Call
 */

export default class HtmlVideoPlayer extends Video {
	constructor(element, options)
	{
		super(element, options)

		this.video 			= element.querySelector('video');
		this.videoMob 		= element.querySelector('.video__mobile');

		if( this.videoMob && window.matchMedia('(max-width:768px)').matches ){
			this.video = this.videoMob;
		}

		for (let option in this.options)
		{
			let bool = this.options[option];
			switch(option)
			{
			case 'autoplay':
				this.video.autoplay = bool;
				if (bool) {
					// Wait for loadedmetadata before attempting to play
					// this.video.muted = true; // Forcing mute to avoid autoplay issues
					this.video.addEventListener('loadedmetadata', () => {
						this.play();
					}, { once: true });
				} else {
					// Pause the video if autoplay is disabled
					this.pause();
				}
				break;
			case 'loop':
				this.video.loop = bool;
				break;
			case 'muted':
				this.video.muted = this.options[option]
				bool ? this.mute() : this.setVolume(1)
				break;
			case 'controls':
				bool ? '' : this.hideControls()
				break;
			case 'progress':
				if (bool)
				{
					this.video.addEventListener('timeupdate', () => {
						this.updateTimeElapsed(this.video.duration, this.video.currentTime)
					});

					this.getSeek(this.video.duration, this.video.currentTime)
				} else
				{
					this.hideProgress()
				}
			}
		}

	}
	play(){
		super.play()
		const playPromise = this.video.play();
		
		if (playPromise !== undefined) {
			playPromise
				.then(() => {
					// Play started successfully
					// console.log("Video started playing");
				})
				.catch(error => {
					// Play was interrupted or failed to start
					console.log("Play interrupted:", error);
				});
		}
	}
	mute(){
		super.mute();
		this.video.muted = true;
		this.buttons.mute && this.buttons.mute.classList.add('muted');
	}
	setVolume(amount){
		super.setVolume(amount)
		this.video.muted = false;
		this.video.volume = 1;
		this.buttons.mute && this.buttons.mute.classList.remove('muted');
	}
	restart()
	{
		super.restart();
		this.video.currentTime = this.video.duration * 0.005;
	}
	pause(){
		super.pause()
		this.video.pause()
	}
	setTime(percentage)
	{
		super.setTime(percentage);
		let seconds = Math.max((percentage / 100) * this.video.duration, 0)
		this.video.currentTime = seconds;
	}
}